export const estadisticasAutomatizacionService = {
  async getEstadisticasAutomatizacion(token = null, fechaDesde = null, fechaHasta = null) {
    try {
      // Obtener el token del localStorage si no se proporciona como parámetro
      const authToken = token || localStorage.getItem('token');

      if (!authToken) {
        throw new Error('No hay token de autenticación');
      }

      // Construir la URL con parámetros de fecha si se proporcionan
      let url = '/api/dashboard/estadisticas-automatizacion';
      if (fechaDesde && fechaHasta) {
        url += `?fdesde=${fechaDesde}&fhasta=${fechaHasta}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('Token expirado o inválido');
        }
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      console.log('📊 [Estadísticas] Datos completos recibidos:', data);

      // Extraer todas las estadísticas de automatización
      if (data.data && data.data[0]) {
        const estadisticasCompletas = data.data[0];
        console.log('📈 [Estadísticas] Todas las estadísticas extraídas:', estadisticasCompletas);
        return estadisticasCompletas;
      } else {
        throw new Error('Estructura de datos inesperada en la respuesta de la API');
      }
    } catch (error) {
      console.error('Error al obtener estadísticas de automatización:', error);
      throw error;
    }
  }
};
